import { Component, Input, AfterViewInit, ViewChild, Output, EventEmitter, ContentChild, ComponentFactoryResolver, ComponentFactory, Injector, EmbeddedViewRef, ApplicationRef } from '@angular/core';

import CustomStore from 'devextreme/data/custom_store';
import 'rxjs/add/operator/toPromise';
import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';
import { DxMenuComponent, DxDataGridComponent, DxTextBoxComponent } from 'devextreme-angular';
import { ServiceCaller } from "../services/ServiceCaller";
import { Promise } from 'q';
import { Deferred } from '../Deferred';
import { DeferObservable } from 'rxjs/observable/DeferObservable';


declare var jQuery: any;

export class GridToolbarItemClickEventArgs {
    index: number;
    data: any;
    name: string;
    handled: boolean = false;
}
export class GridToolbarItemPreperingEventArgs {
    name: string;
    data: any;
    visible: boolean = true;
    disabled: boolean = false;
}

export class GridRowDbClickEventArgs {
    data: any;
    key: any;
    index: boolean = true;
    handled: boolean = false;
}


@Component({
    selector: 'dxs-datasource',
    template: ''
})
export class DXGridToolbarDataSourceComponent {

    // Load Url
    @Output() loadUrlChange = new EventEmitter<string>();
    private _loadUrl: string = null;
    @Input()
    get loadUrl(): string {
        return this._loadUrl;
    }
    set loadUrl(val: string) {
        this._loadUrl = val;
        this.loadUrlChange.emit(this._loadUrl);
    }

    // Load Url
    @Output() updateUrlChange = new EventEmitter<string>();
    private _updateUrl: string = null;
    @Input()
    get updateUrl(): string {
        return this._updateUrl;
    }
    set updateUrl(val: string) {
        this._updateUrl = val;
        this.updateUrlChange.emit(this._updateUrl);
    }

    // Load Url
    @Output() insertUrlChange = new EventEmitter<string>();
    private _insertUrl: string = null;
    @Input()
    get insertUrl(): string {
        return this._insertUrl;
    }
    set insertUrl(val: string) {
        this._insertUrl = val;
        this.insertUrlChange.emit(this._insertUrl);
    }


    // Remove Url
    @Output() removeUrlChange = new EventEmitter<string>();
    private _removeUrl: string = null;
    @Input()
    get removeUrl(): string {
        return this._removeUrl;
    }
    set removeUrl(val: string) {
        this._removeUrl = val;
        this.insertUrlChange.emit(this._removeUrl);
    }


    // Load Url
    @Output() loadParamsChange = new EventEmitter<any>();
    private _loadParams: any = null;
    @Input()
    get loadParams(): any {
        return this._loadParams;
    }
    set loadParams(val: any) {
        this._loadParams = val;
        this.loadParamsChange.emit(this._loadParams);
    }

    // Save Url
    @Output() saveParamsChange = new EventEmitter<any>();
    private _saveParams: any = null;
    @Input()
    get saveParams(): any {
        return this._saveParams;
    }
    set saveParams(val: any) {
        this._saveParams = val;
        this.loadParamsChange.emit(this._saveParams);
    }
}




@Component({
    selector: 'dx-grid-toolbar',
    templateUrl: './dx-gridtoolbar.component.html',
    entryComponents: [DxMenuComponent]
})
export class DXGridToolbarComponent {

    @ViewChild(DxMenuComponent) menu: DxMenuComponent;
    @ViewChild("searchBox") searchBox: DxTextBoxComponent;
    @ContentChild(DxDataGridComponent) grid: DxDataGridComponent;
    @ContentChild(DXGridToolbarDataSourceComponent) dataSource: DXGridToolbarDataSourceComponent;


    @Output() onButtonClick = new EventEmitter<string>();
    @Output() onMenuItemClick = new EventEmitter<GridToolbarItemClickEventArgs>();
    @Output() onMenuItemPrepering = new EventEmitter<GridToolbarItemPreperingEventArgs>();
    @Output() onCancelEditRow = new EventEmitter<any>();
    @Output() onRowDbClick = new EventEmitter<GridRowDbClickEventArgs>();



    allowEdit: boolean = false;
    allowDelete: boolean = false;
    allowInsert: boolean = false;

    hasSelected: boolean = false;
    hasMultiSelected: boolean = false;

    @Input()
    guid: string = null;

    @Input()
    caption: string = null;

    @Input()
    showSearchBar: boolean = true;


    // Items
    private _rowMenuItems: any[] = [];
    @Input()
    get rowMenuItems(): any[] {
        return this._rowMenuItems;
    }

    set rowMenuItems(val: any[]) {
        this._rowMenuItems = val;
    }

    // Header Items
    private _headerMenuItems: any[] = [];
    @Input()
    get headerMenuItems(): any[] {
        return this._headerMenuItems;
    }

    set headerMenuItems(val: any[]) {
        this._headerMenuItems = val;
    }



    constructor(
        private resolver: ComponentFactoryResolver,
        private injector: Injector,
        private appRef: ApplicationRef,
        private service: ServiceCaller
    ) {

    }



    createDataSource() {
        var dataSource: any = {};
        dataSource.store = new CustomStore({
            key: "ID",
            load: (loadOptions) => {
                loadOptions.requireTotalCount = false;
                let params: any = {};
                params.Skip = loadOptions.skip;
                params.Take = loadOptions.take;
                params.SearchQuery = loadOptions.searchExpr;
                Object.assign(params, this.dataSource.loadParams);
                //
                let deferred: Deferred<any> = new Deferred<any>();

                if (this.dataSource.loadUrl) {
                    this.service.get(this.dataSource.loadUrl, params).then(data => {
                        deferred.resolve(data);
                    }).catch(error => {
                        deferred.reject(error);
                    });
                }
                else {
                    deferred.resolve([]);
                }

                return deferred.promise;
            },
            update: (key, values) => {
                let deferred: Deferred<any> = new Deferred<any>();

                if (this.dataSource.updateUrl) {
                    this.grid.instance.byKey(key).then(row => {
                        let data: any = Object.assign(row, values);
                        if (this.dataSource.saveParams) {
                            Object.assign(data, this.dataSource.saveParams);
                        }
                        this.service.post(this.dataSource.updateUrl, data).then(d => {
                            deferred.resolve(true);
                        }).catch(error => {
                            deferred.reject(error);
                        });
                    })
                }
                else {
                    deferred.resolve(true);
                }

                return deferred.promise;
            },
            insert: (values) => {
                let deferred: Deferred<any> = new Deferred<any>();

                if (this.dataSource.insertUrl) {
                    let data: any = Object.assign({}, values);
                    if (this.dataSource.saveParams) {
                        Object.assign(data, this.dataSource.saveParams);
                    }
                    this.service.post(this.dataSource.insertUrl, data).then(d => {
                        deferred.resolve(d);
                    }).catch(error => {
                        deferred.reject(error);
                    });
                }
                else {
                    deferred.resolve(true);
                }

                return deferred.promise;
            },
            remove: (key) => {
                let deferred: Deferred<any> = new Deferred<any>();
                if (this.dataSource.removeUrl) {
                    var list: any[] = [];
                    list.push(key);
                    this.service.post(this.dataSource.removeUrl, list).then(d => {
                        deferred.resolve(d);
                    }).catch(error => {
                        deferred.reject(error);
                    });
                }
                else {
                    deferred.resolve(true);
                }
                return deferred.promise;
            }
        });
        return dataSource;
    }

    ngOnInit() {
        this.grid.columnResizingMode = "widget";

        this.grid.onToolbarPreparing.subscribe((e) => {
            e.toolbarOptions.visible = false;
        });

        // this.grid.onCellPrepared.subscribe((e) => {
        //     if (e.column.command === 'edit') {
        //         debugger;
        //         jQuery(e.cellElement).on('click', '[aria-label=Cancel]', function () {
        //             alert('cancelled');
        //         });
        //     }
        // });

        this.grid.onEditorPreparing.subscribe(this.onEditorPreparing);
        //
        this.grid.onSelectionChanged.subscribe(this.onSelectionChanged);
        // Provide double click for grid  
        this.grid.onRowClick.subscribe(this.onRowClick);
        // provide shortcuts
        this.grid.onKeyDown.subscribe(this.onKeyDown);
    }

    ngAfterViewInit() {
        if (this.dataSource)
            this.grid.dataSource = this.createDataSource();

        this.allowInsert = this.grid.editing.allowAdding;
        this.allowEdit = this.grid.editing.allowUpdating;
        this.allowDelete = this.grid.editing.allowDeleting;
        //
        if (this.guid) {
            //this.grid.instance.option("stateStoring.enabled", true);
            this.grid.instance.option("stateStoring.storageKey", this.guid);
        }
        this.grid.instance.option("scrolling.showScrollbar", "always");
        this.grid.instance.option("scrolling.useNative", "true");
        this.grid.hoverStateEnabled = true;
        this.grid.columnAutoWidth = false;
        this.grid.rowAlternationEnabled = true;
        this.grid.showRowLines = true;
        this.grid.showBorders = true;
        this.grid.allowColumnReordering = true;
        this.grid.allowColumnResizing = true;

        this.grid.onSelectionChanged.subscribe(e => {
            let count = this.grid.instance.getSelectedRowKeys().length;
            this.hasSelected = count > 0;
            this.hasMultiSelected = count > 1;
        });
        this.grid.onContentReady.subscribe(e => {
            this.grid.editing.allowAdding = false;
            this.grid.editing.allowUpdating = false;
            this.grid.editing.allowDeleting = false;
            e.component.columnOption("command:edit", "visible", false);
            e.component.getVisibleColumns().forEach(column => {
                if (column.dataType == "date") {
                    e.component.columnOption(column.dataField, "format", "dd/MM/yyyy");
                }
            });
        });

        this.grid.onCellPrepared.subscribe(this.onCellPrepared);
    }


    private onEditorPreparing = (e) => {

    }

    private onSelectionChanged = (e) => {
        // if(this.onMenuItemPrepering)
        // {
        //     this.rowMenuItems.forEach(item => {
        //         this.onMenuItemPrepering()
        //     });

        // }
    }

    private onRowClick = (e) => {

        let component = e.component;
        let prevClickTime: any = component.lastClickTime2;
        component.lastClickTime2 = new Date();
        if (e.rowType == "data") {
            let event = new GridRowDbClickEventArgs();
            event.data = e.data;
            event.index = e.rowIndex;
            event.key = e.key;
            //
            if (prevClickTime && (component.lastClickTime2 - prevClickTime < 300)) {
                this.onRowDbClick.emit(event);
                if (!event.handled) {
                    let defaults = this.rowMenuItems ? this.rowMenuItems.filter(c => c.default) : [];
                    if (defaults.length) {
                        this.menuClick({ rowIndex: e.rowIndex }, { itemData: { name: defaults[0].name } });
                    }
                    else {
                        this.menuClick({ rowIndex: e.rowIndex }, { itemData: { name: "DXEdit" } });
                    }
                }
            }
            else {
            }
        }
    }

    private onKeyDown = (e) => {
        let grid = this.grid.instance;
        let keys = grid.getSelectedRowKeys();
        let rowIndex = -1;
        let rowData = null;
        if (keys.length == 1) {
            rowIndex = grid.getRowIndexByKey(keys[0]);
            rowData = grid.getSelectedRowsData()[0];
        }

        switch (e.event.code) {
            case 'Escape':
                this.menuClick({}, { itemData: { name: "DXCancel" } });
                break

            case 'Enter':
            case 'NumpadEnter':
                {
                    debugger;
                    e.preventDefault();
                    this.grid.instance.closeEditCell();
                    this.onSaveClick();
                    break;
                }
        }
    }

    public isInEditing(): boolean {
        return this.grid.instance && this.grid.instance.getVisibleRows().findIndex(c => c.isEditing == true) > -1;
    }

    editingRow(): any {
        debugger;
        let editRow = this.grid.instance.getVisibleRows().find(c => c.isEditing);
        return editRow ? editRow.data : null;
    }

    private menuClick(e: any, d: any) {
        let item = new GridToolbarItemClickEventArgs();
        item.data = e.data;
        item.name = d.itemData.name;
        switch (item.name) {

            case "root":
                return;
            case "DXDelete":
                {
                    this.onMenuItemClick.emit(item);
                    if (item.handled == false) {
                        this.removeSelectedRow();
                    }
                    break;
                }
            case "DXInsert":
                {
                    this.onMenuItemClick.emit(item);
                    if (item.handled == false && this.allowInsert)
                        this.grid.instance.addRow();
                    break;
                }
            case "DXSelectedDelete":
                {
                    this.onMenuItemClick.emit(item);
                    break;
                }
            case "DXEdit":
                {
                    this.onMenuItemClick.emit(item);
                    if (item.handled == false && this.allowEdit)
                        this.grid.instance.editRow(e.rowIndex);

                    break;
                }
            case "DXSave":
                {
                    debugger;
                    item.data = this.editingRow();
                    this.onMenuItemClick.emit(item);
                    if (item.handled == false)
                        this.grid.instance.saveEditData();
                    break;
                }
            case "DXCancel":
                {
                    this.onMenuItemClick.emit(item);
                    if (item.handled == false) {
                        this.onCancelEditRow.emit(item);
                        this.grid.instance.cancelEditData();
                    }
                    break;
                }
            case "DXToggleFilterRow":
                {
                    this.grid.instance.option({ filterRow: { visible: !this.grid.filterRow.visible } });
                    break;
                }

            case "DXColumnChooser":
                {
                    this.grid.instance.showColumnChooser();
                    break;
                }
            default:
                this.onMenuItemClick.emit(item);
        }
    }

    private onCellPrepared = (e) => {
        //
        if (e.rowType === "data" && e.column.dataType === "date") {
        }
        if (e.rowType === "data" && e.column.dataType === "dateTime") {

        }
        if (e.rowType === "data" && e.column.dataType === "shortDateTime") {

        }
        if (e.rowType == "data" && e.column.dataType == "time") {

        }
    };




    private removeSelectedRow() {
        let keys = this.grid.instance.getSelectedRowKeys()
        for (var i in keys) {
            var key = keys[i];
            var index = this.grid.instance.getRowIndexByKey(key);
            this.grid.instance.deleteRow(index);
        }
    }

    onRefreshClick() {
        this.grid.instance.refresh();

    }

    onInsertClick() {
        this.menuClick({}, { itemData: { name: "DXInsert" } });
    }

    onCancelClick() {
        this.menuClick({}, { itemData: { name: "DXCancel" } });
    }

    onSaveClick() {
        this.menuClick({}, { itemData: { name: "DXSave" } });
    }

    onUpdateClick() {
        let keys = this.grid.instance.getSelectedRowKeys()
        if (keys.length) {
            let index = this.grid.instance.getRowIndexByKey(keys[0]);
            this.menuClick({ rowIndex: index }, { itemData: { name: "DXEdit" } });
        }
    }

    onRemoveClick() {
        this.removeSelectedRow();
    }

    onMenuClick(name) {
        let event = new GridToolbarItemClickEventArgs();
        event.name = name;
        let keys = this.grid.instance.getSelectedRowKeys()
        if (keys.length) {
            event.data = this.grid.instance.getSelectedRowsData()[0]
        }
        this.onMenuItemClick.emit(event);
    }




    searchOnEnter(e) {
        this.grid.instance.searchByText(this.searchBox.value);
    }
}





// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/shared/components/dx-gridtoolbar.component.ts